export default __webpack_public_path__ + "static/media/bg-bottom.1db17021.png";